import React from 'react'
import { FormTextarea, FormGroup } from 'shards-react'
import PropTypes from 'prop-types'

const InputName = props => {
    const { value, placeholder, required, onChange, valid, invalid, readOnly } = props
    return (
        <FormGroup>
            <FormTextarea
                disabled={readOnly}
                name={'name'}
                required={required}
                defaultValue={value}
                onChange={e => onChange(e)}
                placeholder={placeholder}
                valid={valid}
                invalid={!!invalid}
            />
        </FormGroup>
    )
}

InputName.propTypes = {
    value: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    valid: PropTypes.bool,
    invalid: PropTypes.any,
    readOnly: PropTypes.bool,
}

export default InputName
